import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'health-board',
  'refills-available-medications',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'medication_refills',
    'medications',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/refills-available-medications-req.js